module.exports = window.THREE;